import {Box, MenuItem} from '@mui/material';
import { IconButton } from '@mui/material';
import ZoneLeaflet from '../../../../components/ZoneLeaflet';
import CustomModal from "../../../../components/Modal/CustomModal";
import {CustomTextField} from "../../../../components/CustomTextField";
import {AddZoneModalApp} from "../Funtionality/AddZoneModalApp"
import {CustomSelectAndChildren} from "../../../../components/CustomSelectAndChildren";
import {DEFAULT_LATITUDE, DEFAULT_LONGITUDE} from "../../../../Apis/functions";
import {CloseIcon} from '../../../../components/buttons/IconButtons';
import React from "react";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @JobTitle: Full Stack Developer
 * @param {Object} props - Component properties
 * @param {string} props.title - Modal title text
 * @param {string} props.check - Flag to determine if father zone should be displayed
 * @param {Object} props.isFatherZone - Data object containing father zone information
 * @param {boolean} props.show - Controls modal visibility
 * @returns {JSX.Element} - React component for adding zones
 * @constructor
 */

const AddZoneModal = (props) => {
    // destructure from prop
    const { title, check, isFatherZone, show ,onHide,modified, setModified} = props;

    const {t,clearButton,handleCreateZone, searchLocation, setSearchLocation, handleCleanClick,name,setName, emptyFields,
        isStatus, setIsStatus, getListStatusZone,latitude, setLatitude, longitude, setLongitude,handleClose
    } = AddZoneModalApp({
        show,
        isFatherZone,
        check,
        onHide,
        modified,
        setModified
    });

    return (
        <>
            <CustomModal {...props}
                         size='lg'
                         aria-labelledby='contained-modal-title-vcenter'
                         centered
                         className='add_zone_modal'
                         onConfirm={handleCreateZone}
                         title={title}
                         rightTitleButton={clearButton()}
                         onHide={handleClose}
                         classNameBody="pt-2"
            >
                <div className='row'>
                    <Box className={"col-12"}>
                        <CustomTextField trans={'search_a_place'} id={'txt_azm_search'} value={searchLocation}
                                         onChange={(e) => setSearchLocation(e.target.value)} name={"searchLocation"}
                                         InputProps={{
                                             endAdornment: (
                                                 <IconButton onClick={handleCleanClick}>
                                                     <CloseIcon  width={16} height={16}/>
                                                 </IconButton>
                                             ),
                                         }}

                        />
                    </Box>
                    <div className='col-md-6 '>
                        {check === 'true' ? (
                            <CustomTextField trans={'father_zone'} id={'txt_azm_fatherZone'} value={isFatherZone?.name}
                                             name={"father_zone"} disabled={true}
                            />
                        ) : (
                            ''
                        )}
                        <CustomTextField trans={'name'}
                                         id={'txt_azm_name'}
                                         value={name}
                                         name={"name"}
                                         onChange={(e) => setName(e.target.value)}
                                         required={true}
                                         emptyFields={emptyFields}
                        />
                        <CustomSelectAndChildren
                                      id={"slt_azm_status"}
                                      name={"status"}
                                      value={isStatus}
                                      key={isStatus}
                                      keyName="id"
                                      onChange={(e) => setIsStatus(e.target.value)}
                                      trans={"status"}
                                      label={"lbl_azm_status"}
                                      required={true}
                                      emptyFields={emptyFields}
                                      showNoSelectionOption={false}
                        >
                            {getListStatusZone?.map((item) => (
                                <MenuItem value={item?.id}>
                                    {t(item?.name).toUpperCase()}
                                </MenuItem>
                            ))}
                        </CustomSelectAndChildren>

                        <div className='d-flex gap-2 align-items-center'>
                            <CustomTextField trans={'latitude'}
                                             id={'txt_azm_latitude'}
                                             value={latitude}
                                             name={"latitude"}
                                             onChange={(e) => setLatitude(e.target.value)}
                                             required={true}
                                             disabled={true}
                                             emptyFields={emptyFields}
                                             helperText={'click_location_in_the_map'}
                            />
                            <CustomTextField trans={'longitude'}
                                             id={'txt_azm_longitude'}
                                             value={longitude}
                                             disabled={true}
                                             name={"longitude"}
                                             onChange={(e) => setLongitude(e.target.value)}
                                             required={true}
                                             emptyFields={emptyFields}
                                             helperText={'click_location_in_the_map'}
                            />
                        </div>
                    </div>
                    <div className='col-md-6 text-center'>
                        <ZoneLeaflet
                            setLatitude={setLatitude}
                            setLongitude={setLongitude}
                            searchLocation={searchLocation}
                            latlng={[
                                sessionStorage.getItem('latitude') === null
                                    ? DEFAULT_LATITUDE
                                    : sessionStorage.getItem('latitude'),
                                sessionStorage.getItem('longitude') === null
                                    ? DEFAULT_LONGITUDE
                                    : sessionStorage.getItem('longitude'),
                            ]}
                            classNameMap={"zone-map-container"}
                        />
                        <p className='seeLocation ibl-font-w-600'>{t('click_location_in_the_map')}</p>
                    </div>
                </div>
            </CustomModal>
        </>
    );
};

export default AddZoneModal;
